
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { configStore, documentStore, uiStore } from "@/store/store";
import { getDocumentUrlFromId } from "@/lib/wordpress/load";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { fetchAvailableDocuments } from "@/lib/document-chooser/document-chooser";
import lodash from "lodash";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import NotificationLogger from "@/lib/notifications/notifications";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    Dropdown,
    TopBarSection
  }
})
export default class DocumentChooser extends Vue {
  open = false;
  search = "";

  isLoading = false;

  get currentDocument() {
    return documentStore.document;
  }

  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  get currentlyEditingLabel() {
    return `${documentStore.document.documentMeta.id.toString()}`;
  }

  get availableDocuments() {
    return configStore.availableDocuments;
  }

  getDocumentUrlFromId(newDocumentId: number) {
    return getDocumentUrlFromId(newDocumentId);
  }

  handleSearch(searchValue: string) {
    this.search = searchValue;
    this.debouncedSearchContentInWp();
  }

  // Average typing speed is a char every 300 ms
  debouncedSearchContentInWp = lodash.debounce(this.searchContentInWp, 600); // this feels slow tho

  async searchContentInWp() {
    this.isLoading = true;

    pipe(
      await fetchAvailableDocuments({
        search: this.search
      }),
      fold(
        errors => {
          this.isLoading = false;
          errors.forEach(e => NotificationLogger.log.message(e.msg));
        },
        availableDocuments => {
          configStore.setAvailableDocuments(availableDocuments);
          this.isLoading = false;
        }
      )
    );
  }
}
